import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { useGetLeadStatusesQuery } from "@/redux/rtk/features/leadStatus/leadStatusApi";
import { useBulkUpdateLeadStatusMutation } from "@/redux/rtk/features/leads/leadsApi";
import { Button, Form, Select } from "antd";
import { useTranslation } from "react-i18next";

export default function BulkUpdateLeadStatus({ selectedRowKeys, onClose, clearSelection }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [bulkUpdateLeadStatus, { isLoading }] = useBulkUpdateLeadStatusMutation();

    const { data: leadStatusList, isLoading: leadStatusLoading } = useGetLeadStatusesQuery();

    const onFinish = async (values) => {
        const payload = {
            ids: selectedRowKeys,
            leadStatusId: values.leadStatusId,
        };
        const resp = await bulkUpdateLeadStatus(payload);
        if (resp.data) {
            form.resetFields();
            clearSelection();
            onClose();
        }
    };

    return (
        <UserPrivateComponent permission="update-lead">
            <div className="mt-5">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    className="flex flex-col gap-4">
                    <Form.Item
                        label={t("lead.leadStatus")}
                        name="leadStatusId"
                        rules={[{ required: true, message: t("lead.leadStatusRequired") }]}>
                        <Select
                            loading={leadStatusLoading}
                            placeholder={t("lead.selectLeadStatus")}
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }>
                            {leadStatusList?.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <div className="flex justify-end gap-2">
                        <Button onClick={onClose}>{t("common.cancel")}</Button>
                        <Button type="primary" htmlType="submit" loading={isLoading}>
                            {t("common.update")}
                        </Button>
                    </div>
                </Form>
            </div>
        </UserPrivateComponent>
    );
}
